import React, {Component} from 'react';
import IconButton from '@material-ui/core/IconButton';
import {withStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import MoveAllDocsToCaseDialog from "./MoveAllDocsToCaseDialog";

const styles = theme => ({});

const INITIAL_STATE = {
    showDialog: false
};

class MoveAllDocsToCaseButton extends Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
    }


    handleClickIcon = (event) => {
        this.setState({
            showDialog: true
        });

    };

    handleCloseDialog = () => {
        this.setState({
            showDialog: false
        });

    };

    render() {

        const { anchorEl } = this.state;

        return (
            <div style={{display: "inline"}}>
                <Tooltip title={this.props.actionConfig.label}>
                    <IconButton
                        aria-label="Menu"
                        aria-owns={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClickIcon}
                        color = "secondary"
                    >
                        <i className='material-icons'>
                            swap_horiz
                        </i>
                    </IconButton>
                </Tooltip>

                {
                    (this.state.showDialog) &&
                    <MoveAllDocsToCaseDialog
                        folderDetails = {this.props.folderDetails}
                        actionConfig={this.props.actionConfig}
                        handleCloseDialog={this.handleCloseDialog}
                        userDetails={this.props.userDetails}
                        triggerRefreshAuthToken={this.props.triggerRefreshAuthToken}
                    />
                }

            </div>
        );
    }
}

MoveAllDocsToCaseButton.propTypes = {
    boxDocID: PropTypes.string.isRequired,
    actionConfig: PropTypes.object.isRequired
};

export default withStyles(styles)(MoveAllDocsToCaseButton);